import { render, staticRenderFns } from "./ActionsComponent.vue?vue&type=template&id=07197127"
import script from "./ActionsComponent.vue?vue&type=script&lang=js"
export * from "./ActionsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports